'use strict';

export const CLICK_TO_VERIFY = 'click_to_verify';
export const VERIFYING = 'verifying';
export const SUCCESS = 'success';
export const UNAVAILABLE = 'unavailable';
export const INCOMPLETE = 'incomplete';
export const ERROR = 'error';
export const TESTING = 'testing';
export const NOTICE = 'notice';

export const STRINGS = {
    'en': {
        [CLICK_TO_VERIFY]: 'Click to verify',
        [VERIFYING]: 'Verifying',
        [SUCCESS]: 'Verified',
        [UNAVAILABLE]: 'Not available',
        [INCOMPLETE]: 'incomplete',
        [ERROR]: 'error',
        [TESTING]: 'testing',
        [NOTICE]: 'notice',
    },
    'de': {
        [CLICK_TO_VERIFY]: 'Zum Bestätigen klicken',
        [VERIFYING]: 'Wird überprüft',
        [SUCCESS]: 'Verifiziert',
        [UNAVAILABLE]: 'Nicht verfügbar',
        [INCOMPLETE]: 'unvollständig',
        [ERROR]: 'fehler',
        [TESTING]: 'testmodus',
        [NOTICE]: 'hinweis',
    },
    'es': {
        [CLICK_TO_VERIFY]: 'Haz clic para verificar',
        [VERIFYING]: 'Verificando',
        [SUCCESS]: 'Verificado',
        [UNAVAILABLE]: 'No disponible',
        [INCOMPLETE]: 'incompleto',
        [ERROR]: 'error',
        [TESTING]: 'prueba',
        [NOTICE]: 'aviso',
    },
    'fr': {
        [CLICK_TO_VERIFY]: 'Cliquez pour vérifier',
        [VERIFYING]: 'Vérification en cours',
        [SUCCESS]: 'Vérifié',
        [UNAVAILABLE]: 'Non disponible',
        [INCOMPLETE]: 'incomplet',
        [ERROR]: 'erreur',
        [TESTING]: 'test',
        [NOTICE]: 'avis',
    },
    'it': {
        [CLICK_TO_VERIFY]: 'Clicca per verificare',
        [VERIFYING]: 'Verifica in corso',
        [SUCCESS]: 'Verificato',
        [UNAVAILABLE]: 'Non disponibile',
        [INCOMPLETE]: 'incompleto',
        [ERROR]: 'errore',
        [TESTING]: 'test',
        [NOTICE]: 'avviso',
    },
    'nl': {
        [CLICK_TO_VERIFY]: 'Klik om te verifiëren',
        [VERIFYING]: 'Bezig met verifiëren',
        [SUCCESS]: 'Geverifieerd',
        [UNAVAILABLE]: 'Niet beschikbaar',
        [INCOMPLETE]: 'onvolledig',
        [ERROR]: 'fout',
        [TESTING]: 'testen',
        [NOTICE]: 'melding',
    },
    'sv': {
        [CLICK_TO_VERIFY]: 'Klicka för att verifiera',
        [VERIFYING]: 'Verifierar',
        [SUCCESS]: 'Verifierad',
        [UNAVAILABLE]: 'Inte tillgänglig',
        [INCOMPLETE]: 'ofullständig',
        [ERROR]: 'fel',
        [TESTING]: 'test',
        [NOTICE]: 'notis',
    },
    'no': {
        [CLICK_TO_VERIFY]: 'Klikk for å bekrefte',
        [VERIFYING]: 'Bekrefter',
        [SUCCESS]: 'Bekreftet',
        [UNAVAILABLE]: 'Ikke tilgjengelig',
        [INCOMPLETE]: 'ufullstendig',
        [ERROR]: 'feil',
        [TESTING]: 'test',
        [NOTICE]: 'varsel',
    },
    'pl': {
        [CLICK_TO_VERIFY]: 'Kliknij, aby zweryfikować',
        [VERIFYING]: 'Weryfikowanie',
        [SUCCESS]: 'Zweryfikowano',
        [UNAVAILABLE]: 'Niedostępne',
        [INCOMPLETE]: 'niekompletne',
        [ERROR]: 'błąd',
        [TESTING]: 'test',
        [NOTICE]: 'uwaga',
    },
    'uk': {
        [CLICK_TO_VERIFY]: 'Натисніть для перевірки',
        [VERIFYING]: 'Виконується перевірка',
        [SUCCESS]: 'Підтверджено',
        [UNAVAILABLE]: 'Недоступно',
        [INCOMPLETE]: 'неповний',
        [ERROR]: 'помилка',
        [TESTING]: 'тестування',
        [NOTICE]: 'увага',
    },
    'tr': {
        [CLICK_TO_VERIFY]: 'Doğrulamak için tıklayın',
        [VERIFYING]: 'Doğrulanıyor',
        [SUCCESS]: 'Doğrulandı',
        [UNAVAILABLE]: 'Kullanılamıyor',
        [INCOMPLETE]: 'eksik',
        [ERROR]: 'hata',
        [TESTING]: 'test',
        [NOTICE]: 'bildirim',
    },
    'fi': {
        [CLICK_TO_VERIFY]: 'Napsauta vahvistaaksesi',
        [VERIFYING]: 'Vahvistetaan',
        [SUCCESS]: 'Vahvistettu',
        [UNAVAILABLE]: 'Ei saatavilla',
        [INCOMPLETE]: 'epätäydellinen',
        [ERROR]: 'virhe',
        [TESTING]: 'testi',
        [NOTICE]: 'ilmoitus',
    },
    'et': {
        [CLICK_TO_VERIFY]: 'Klõpsa kinnitamiseks',
        [VERIFYING]: 'Kinnitamine',
        [SUCCESS]: 'Kinnitatud',
        [UNAVAILABLE]: 'Pole saadaval',
        [INCOMPLETE]: 'puudulik',
        [ERROR]: 'viga',
        [TESTING]: 'test',
        [NOTICE]: 'teade',
    }
};
